import React from 'react';
import irelandApi from '../irelandApi';
import { actions } from 'react-redux-form';
import { toast } from 'react-toastify';
import store, { history } from '../store';
import ToastMessage from '../components/common/toast-message';
import {getOrderNow, updateDeliveryAddress} from './orders';
import { getMyProfile } from './user';
import setAuthorizationToken from '../utils/tokenUtils';
import {toInt} from '../utils/commonFunctions'

const ADMIN_ASSESSMENTS_URL = '/api/admin/assessments';
const ASSESSMENTS_URL = '/api/assessments';

export const getAssessments = () => (dispatch) => {
  dispatch({
    type: 'GET_ASSESSMENTS_PENDING',
    payload: []
  });

  return irelandApi
    .get(ASSESSMENTS_URL)
    .then((response) => {
      dispatch({
        type: 'GET_ASSESSMENTS_FULFILLED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_ASSESSMENTS_REJECTED',
        payLoad: error.data
      });

      return Promise.reject(error.response.data);
    });
};

export const getAdminAssessments = (filter = '', page = '') => dispatch => {
  dispatch({
    type: 'GET_ASSESSMENTS_PENDING',
    payload: []
  });
  return irelandApi
    .get(ADMIN_ASSESSMENTS_URL, { params: { q: filter, page: page } })
    .then(response => {
      dispatch({
        type: 'GET_ADMIN_ASSESSMENTS_FULFILLED',
        payLoad: response.data
      });
    })
    .catch(error => {
      dispatch({
        type: 'GET_ASSESSMENTS_REJECTED',
        payLoad: error.data
      });
      return Promise.reject(error.response.data);
    });
};

export const getAssessment = (id) => (dispatch) => {
  dispatch({type: 'GET_ASSESSMENT_PENDING'});
  return irelandApi.get(`${ADMIN_ASSESSMENTS_URL}/${id}`)
    .then((response) => {
      dispatch({
        type: 'GET_ASSESSMENT_FETCHED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_ASSESSMENT_REJECTED',
        payLoad: error.response
      })
    })
};

const prepareAssessmentFormData = (payLoad) => {
  let formData = new FormData();
  Object.keys(payLoad).forEach(key => {
      formData.append(`assessment[${key}]`, payLoad[key])
  });
  return formData;
};


export const saveAssessment = (payLoad, _) => {
  let formData = prepareAssessmentFormData(payLoad);

  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  };

  return irelandApi.post(ADMIN_ASSESSMENTS_URL, formData, config)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Assessment has been saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Error while saving Assessment"/>);

      const errorData = error.hasOwnProperty('response') ? error.response.data.errors : [];

      return Promise.reject(errorData);
    })
};

export const updateAssessment = (id, payLoad, _) => {
  let formData = prepareAssessmentFormData(payLoad);

  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  };

  return irelandApi.patch(`${ADMIN_ASSESSMENTS_URL}/${id}`, formData, config)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Assessment has been saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Error while saving Assessment"/>);

      const errorData = error.hasOwnProperty('response') ? error.response.data.errors : [];

      return Promise.reject(errorData);
    }).then(() => {
      history.push('/admin/assessments');
    });
};



// WEBPACK FOOTER //
// ./src/actions/assessments.js